var map = {
	"./legal/pages/review": [
		53590,
		[
			6321,
			894,
			9300,
			3959,
			8839,
			5443,
			6671,
			5702,
			7137,
			2954,
			804,
			6588,
			1192,
			3571,
			8861,
			7000,
			8914,
			4755,
			1829,
			6461,
			1225
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5488;
module.exports = webpackAsyncContext;